import { render, staticRenderFns } from "./ProductBrand.vue?vue&type=template&id=69dd76d0&"
import script from "./ProductBrand.vue?vue&type=script&lang=ts&"
export * from "./ProductBrand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports